import { render, staticRenderFns } from "./BeforeYouUpgradeModal.vue?vue&type=template&id=4f5ce0e9"
import script from "./BeforeYouUpgradeModal.vue?vue&type=script&lang=js"
export * from "./BeforeYouUpgradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports